import React, { useEffect, useRef, useState } from 'react';
// import { Route, Routes } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Controller, Mousewheel } from 'swiper';

import { About, Contact, Header, Home, Portfolio } from './components';

const mokSwoper = [
  {
    id: 1,
    element: <Home />,
  },
  {
    id: 2,
    element: <About />,
  },
  {
    id: 3,
    element: <Portfolio />,
  },
  {
    id: 4,
    element: <Contact />,
  },
];

export const App = () => {
  const [swiperRef, setSwiperRef] = useState(null) as any;
  const [swiperActive, setSwiperActive] = useState(null) as any

  const slideTo = (index: number) => {
    swiperRef.slideTo(index - 1, 0);
  };

  return (
    <div>
      <Header swiperActive={swiperActive} slideTo={slideTo} />
      {/* <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
      </Routes> */}
      <Swiper
        onSlideChange={(e) => setSwiperActive(e.realIndex)}
        direction={'vertical'}
        slidesPerView={1}
        spaceBetween={30}
        mousewheel={true}
        onSwiper={setSwiperRef}
        modules={[Mousewheel]}
        className="mySwiper1">
        {mokSwoper.map((item) => (
          <SwiperSlide key={item.id}>{item.element}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
